import { render, staticRenderFns } from "./ValidateButton.vue?vue&type=template&id=5880bbc6&scoped=true&"
import script from "./ValidateButton.vue?vue&type=script&lang=js&"
export * from "./ValidateButton.vue?vue&type=script&lang=js&"
import style0 from "./validateButton.scss?vue&type=style&index=0&id=5880bbc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880bbc6",
  null
  
)

export default component.exports